
document.querySelectorAll('.tab-item').forEach(item => {
  item.addEventListener('click', function() {
    document.querySelectorAll('.tab-item').forEach(tab => tab.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(content => content.classList.remove('active'));

    this.classList.add('active');
    document.getElementById(this.getAttribute('data-tab')).classList.add('active');
  });
});

const urlParams = new URLSearchParams(window.location.search);
const colorFromURL = urlParams.get('color'); // Assuming the URL is something like ?color=red

document.querySelectorAll('.color-swatches label').forEach(function(label) {
    if (label.getAttribute('for') === colorFromURL) {
        label.click(); // Trigger click to ensure everything updates
    }
});

 // Color radio buttons 
  document.querySelectorAll('.color-swatches input[name="color"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Color:', this.value);
      }
    });
  });

 // Size radio buttons for Top
  document.querySelectorAll('input[name="top-size"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Top Size:', this.value);
      }
    });
  });

  // Material radio buttons for Top
  document.querySelectorAll('input[name="top-material"]').forEach(function(materialInput) {
    materialInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Top Material:', this.value);
      }
    });
  });

  // Size radio buttons for Bottom
  document.querySelectorAll('input[name="bottom-size"]').forEach(function(sizeInput) {
    sizeInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Bottom Size:', this.value);
      }
    });
  });

  // Material radio buttons for Bottom
  document.querySelectorAll('input[name="bottom-material"]').forEach(function(materialInput) {
    materialInput.addEventListener('change', function() {
      if (this.checked) {
        console.log('Selected Bottom Material:', this.value);
      }
    });
  });

// Function to get selected values and return variant IDs
function getSelectedValues() {
  var selectedColor = document.querySelector('input[name="color"]:checked')?.value;
  var selectedTopSize = document.querySelector('input[name="top-size"]:checked')?.value;
  var selectedTopMaterial = document.querySelector('input[name="top-material"]:checked')?.value;
  var selectedBottomSize = document.querySelector('input[name="bottom-size"]:checked')?.value;
  var selectedBottomMaterial = document.querySelector('input[name="bottom-material"]:checked')?.value;

  if (!selectedColor || !selectedTopSize || !selectedTopMaterial || !selectedBottomSize || !selectedBottomMaterial) {
    console.log('Not all selections are made.');
    return { topVariantId: null, bottomVariantId: null };
  }

  // Capitalize words
  function capitalizeWords(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }

  selectedColor = capitalizeWords(selectedColor);

  var topPossibleTitles = [
    `${selectedColor} / ${selectedTopSize} / ${selectedTopMaterial}`,
    `${selectedTopSize} / ${selectedColor} / ${selectedTopMaterial}`,
    `${selectedTopMaterial} / ${selectedColor} / ${selectedTopSize}`,
    `${selectedColor} / ${selectedTopMaterial} / ${selectedTopSize}`,
    `${selectedTopSize} / ${selectedTopMaterial} / ${selectedColor}`,
    `${selectedTopMaterial} / ${selectedTopSize} / ${selectedColor}`
  ];

  var bottomPossibleTitles = [
    `${selectedColor} / ${selectedBottomSize} / ${selectedBottomMaterial}`,
    `${selectedBottomSize} / ${selectedColor} / ${selectedBottomMaterial}`,
    `${selectedBottomMaterial} / ${selectedColor} / ${selectedBottomSize}`,
    `${selectedColor} / ${selectedBottomMaterial} / ${selectedBottomSize}`,
    `${selectedBottomSize} / ${selectedBottomMaterial} / ${selectedColor}`,
    `${selectedBottomMaterial} / ${selectedBottomSize} / ${selectedColor}`
  ];

  var topDropdown = document.getElementById('top-variant-dropdown');
  var bottomDropdown = document.getElementById('bottom-variant-dropdown');

  var topVariantId = null;
  var bottomVariantId = null;

  for (var i = 0; i < topDropdown.options.length; i++) {
    var topOption = topDropdown.options[i];
    if (topPossibleTitles.includes(topOption.text)) {
      topVariantId = topOption.value;
      topQuantity = topOption.getAttribute('data-quantity');
      break;
    }
  }

  for (var j = 0; j < bottomDropdown.options.length; j++) {
    var bottomOption = bottomDropdown.options[j];
    if (bottomPossibleTitles.includes(bottomOption.text)) {
      bottomVariantId = bottomOption.value;
      bottomQuantity = bottomOption.getAttribute('data-quantity');
      break;
    }
  }

  console.log('Selected Top Variant ID:', topVariantId, 'Quantity:', topQuantity);
  console.log('Selected Bottom Variant ID:', bottomVariantId, 'Quantity:', bottomQuantity);

  return { topVariantId, topQuantity, bottomVariantId, bottomQuantity };
}

// Function to add both variants to the cart
function addToCart(topVariantId, bottomVariantId) {
  Promise.all([topVariantId, bottomVariantId])
    .then(results => {
      var topAvailable = results[0];
      var bottomAvailable = results[1];

      if (topAvailable && bottomAvailable) {
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('items[0][id]', topVariantId);
        formData.append('items[0][quantity]', 1);
        formData.append('items[1][id]', bottomVariantId);
        formData.append('items[1][quantity]', 1);
        
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        console.log('config', config);
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log('Products added to cart:', response, cart);
            if (cart && response) {
              try {
                cart.renderContents(response);
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                  cartDrawer.classList.remove('is-empty');
                }
              } catch (error) {
                  console.error('Error rendering cart contents:', error);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
      } else {
        console.log('One or both variants are sold out.');
        // Optionally show a message to the user about sold-out items
      }
    });
}

// Function to update button state based on availability
function updateButtonState() {
  var { topVariantId, topQuantity, bottomVariantId, bottomQuantity } = getSelectedValues();

  var topAvailable = topQuantity > 0;
  var bottomAvailable = bottomQuantity > 0;

  console.log('Top available:', topAvailable);
  console.log('Bottom available:', bottomAvailable);

  var button = document.getElementById('add-to-cart-button');
  button.disabled = !(topAvailable && bottomAvailable);
}

// Event listener for the button click
document.getElementById('add-to-cart-button').addEventListener('click', function() {
  var { topVariantId, bottomVariantId } = getSelectedValues();
  if (topVariantId && bottomVariantId) {
    addToCart(topVariantId, bottomVariantId);
  } else {
    console.log('Top or bottom variant ID not found.');
  }
});

// Event listener for variant selection changes
document.querySelectorAll('input[name="color"], input[name="top-size"], input[name="top-material"], input[name="bottom-size"], input[name="bottom-material"]').forEach(function(input) {
  input.addEventListener('change', function() {
    updateButtonState();
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const colorRadios = document.querySelectorAll('.color-radio');
  const selectedColorName = document.querySelector('.selected-color-name');

  function updateSelectedColor() {
    const checkedRadio = document.querySelector('.color-radio:checked');
    if (checkedRadio && selectedColorName) {
      selectedColorName.textContent = checkedRadio.value;
    }
  }

  // Initial load update
  updateSelectedColor();

  // On change update
  colorRadios.forEach(radio => {
    radio.addEventListener('change', updateSelectedColor);
  });
});